import automobyApi from '../Api';

export const useAgentCRMCarFile = () => {
  const fetchList = async (carId) => {
    try {
      const response = await automobyApi.post("/agentcrm/car-file/list", { car_id: carId });
      return response.data.items || [];
    } catch (error) {
      console.error(error);
      return [];
    }
  };

  const toFormData = (item) => {
    const formData = new FormData();
    formData.append("agent_id", item.agent_id || 0);
    formData.append("car_id", item.car_id || 0);

    if (item.file_upload) {
      formData.append("file", item.file_upload);
    }

    return formData;
  };

  const add = async (newData) => {
    try {
      const response = await automobyApi.post("/agentcrm/car-file/create", toFormData(newData), {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      console.error(error);
    }
  };

  const remove = async (id) => {
    const response = await automobyApi.post("/agentcrm/car-file/delete", { id });
    return response.data;
  };

  return {
    agentCRMCarFileService: {
      fetchList,
      add,
      remove,
    }
  };
};
